import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export const TransformationSummary = () => {
  return <section className="mb-12" data-id="element-395">
      <p className="mb-6 text-gray-800 leading-relaxed" data-id="element-396">
        Lisa herkent dit moment: "Het kwartje viel toen Amee uitlegde hoe honden
        vanuit hun natuur gewend zijn met elkaar om te gaan. Ik begreep dat
        Benny helemaal niet koppig was - hij begreep mij gewoon niet, net zoals
        ik hem niet begreep. We hadden gewoon langs elkaar heen gecommuniceerd."
      </p>

      <div className="bg-blue-50 border border-blue-100 rounded-xl p-8" data-id="element-397">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-398">
          Wat deelnemers ontdekken:
        </h3>

        <div className="space-y-5 mb-8" data-id="element-399">
          <div className="flex items-start" data-id="element-400">
            <CheckCircle2Icon className="w-7 h-7 text-green-500 mr-4 mt-0.5 flex-shrink-0" data-id="element-401" />
            <p className="text-lg text-gray-800" data-id="element-402">
              <span className="font-bold" data-id="element-403">Dat onrustige gedrag?</span> Vaak
              mentale vermoeidheid, niet fysieke energie.
            </p>
          </div>
          <div className="flex items-start" data-id="element-404">
            <CheckCircle2Icon className="w-7 h-7 text-green-500 mr-4 mt-0.5 flex-shrink-0" data-id="element-405" />
            <p className="text-lg text-gray-800" data-id="element-406">
              <span className="font-bold" data-id="element-407">Die korte blikken naar de deur?</span>{' '}
              Je hond probeert je mee te nemen naar iets interessants.
            </p>
          </div>
          <div className="flex items-start" data-id="element-408">
            <CheckCircle2Icon className="w-7 h-7 text-green-500 mr-4 mt-0.5 flex-shrink-0" data-id="element-409" />
            <p className="text-lg text-gray-800" data-id="element-410">
              <span className="font-bold" data-id="element-411">
                Dat wegkijken wanneer je hem roept?
              </span>{' '}
              Respect, geen negeren.
            </p>
          </div>
        </div>

        <p className="text-lg text-gray-800 leading-relaxed italic" data-id="element-412">
          In 90 minuten leer je eindelijk wat je hond al die tijd probeerde te
          zeggen. Het eerstvolgende gratis{' '}
          <span className="text-blue-600 not-italic" data-id="element-413">webinar</span> is vandaag
          en morgen.
        </p>
      </div>

      <p className="text-xl text-gray-900 font-bold text-center mt-8" data-id="element-414">
        Soms kan anderhalf uur alles veranderen in de relatie met je hond
      </p>
    </section>;
};